module.exports = __webpack_public_path__ + "img/95.23a1d79f.jpg";